import React, { useEffect } from "react";

export default function LiveInternetCounter() {
  useEffect(() => {
    (function (d, s) {
      const img = d.getElementById("licntDD32");
      if (img) {
        img.src =
          "https://counter.yadro.ru/hit?t11.6;r" +
          escape(d.referrer) +
          (s
            ? ";s" +
              s.width +
              "*" +
              s.height +
              "*" +
              (s.colorDepth ? s.colorDepth : s.pixelDepth)
            : "") +
          ";u" +
          escape(d.URL) +
          ";h" +
          escape(d.title.substring(0, 150)) +
          ";" +
          Math.random();
      }
    })(document, window.screen);
  }, []);

  return (
    <a
      href="https://www.liveinternet.ru/click"
      target="_blank"
      rel="noreferrer"
    >
      <img
        id="licntDD32"
        width="88"
        height="31"
        style={{ border: 0 }}
        title="LiveInternet: показано число просмотров за 24 часа, посетителей за 24 часа и за сегодня"
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAIBTAA7"
        alt=""
      />
    </a>
  );
}
